import { UseFormRegister, FieldValues, Path } from "react-hook-form";

import TextareaAutosize from "@mui/material/TextareaAutosize";

interface AutoResizeTextAreaProps<T extends FieldValues> {
  register: UseFormRegister<T>;
  fieldName: Path<T>;
  placeholder?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  minRows?: number;
}

export const AutoResizeTextArea = <T extends FieldValues>({
  register,
  fieldName,
  placeholder = "",
  value,
  minRows,
  onChange,
}: AutoResizeTextAreaProps<T>) => {
  return (
    <TextareaAutosize
      {...register(fieldName)}
      placeholder={placeholder}
      className="w-full bg-white rounded-md resize-none overflow-hidden text-sm focus:outline-none focus:ring-0 placeholder-grey1-200"
      value={value}
      onChange={onChange}
      minRows={minRows}
      style={{ width: "100%" }}
    />
  );
};
